import { MenuIdPeople } from '@jira/navigation-apps__constants/src/MenuIdPeople.tsx';
import {
	AsyncHorizontalOperationsNav,
	LazyHorizontalOperationsNav,
} from '@jira/navigation-apps__horizontal-nav-jsm-operations-container/src/async.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { LazyTeamDashboardSidebar } from '@jira/navigation-apps__sidebar-eoc-team-dashboard/src/async.tsx';
import { opsTeamLayout } from '@jira/platform__layouts-ops-team-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { teamIntegrationDetailRoute } from '@jira/router-routes__eoc-integration-automation-routes/src/teamIntegrationDetailRoute.tsx';
import { resources as teamDashboardResources } from '@atlassian/eoc-team-dashboard/resources';
import { resources as integrationAutomationResources } from '@atlassian/eoc-integration-automation/resources';
import type { Route } from '@atlassian/react-resource-router';
import { IntegrationAutomation } from './ui/IntegrationAutomation.tsx';
import { IntegrationDetail } from './ui/IntegrationDetail.tsx';
import { LazyIntegrationAutomation } from './ui/async.tsx';

export const teamIntegrationDetailRouteEntry: Route = createEntry(
	teamIntegrationDetailRoute,
	() => ({
		group: 'eoc',
		basePath: '/jira/ops/teams',
		// eslint-disable-next-line no-restricted-syntax
		component: IntegrationAutomation,
		layout: opsTeamLayout,
		slot: IntegrationDetail,

		resources: [
			...getNavigationResources(),
			...teamDashboardResources(),
			getConsolidationStateResource(),
			integrationAutomationResources.configuredIntegrationsResource,
			integrationAutomationResources.userAccessRightsResource,
		],

		navigation: {
			menuId: MenuIdPeople,
			horizontal: AsyncHorizontalOperationsNav,
		},

		forPaint: [
			LazyHorizontalOperationsNav,
			LazyAtlassianNavigation,
			LazyIntegrationAutomation,
			LazyTeamDashboardSidebar,
		],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
